module.exports = __webpack_public_path__ + "assets/img/mecha-7dd084f3.png";